module.exports = __webpack_public_path__ + "img/11@2x.a553c91c.png";